import React from 'react';
import { shape, string, bool } from 'prop-types';

const Result = ( result ) => {

    const resultData = result.attributes;

    return (

        <div className='data-release-archive-filter-result'>

            <ul>
                { resultData.pdf ? <li data-pdf><a href = { resultData.url } target='_blank' rel='noopener noreferrer'> { resultData.title } </a></li> : <li><a href = { resultData.url } target='_blank' rel='noopener noreferrer'> { resultData.title } </a></li> }
            </ul>

        </div>
    );

};

Result.propTypes = {
    type: string,
    normalizedType: string,
    id: string,
    attributes: shape( {
        title: string,
        url: string,
        pdf: bool
    } )
};

export default Result;